import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'discontinued-info-popup',
  templateUrl: './discontinued-info-popup.html',
  standalone: false,
})
export class DiscontinuedInfoPopupComponent {
  @Output() close: EventEmitter<void> = new EventEmitter();

  onClose(): void {
    this.close.emit();
  }
}

